module.exports = __webpack_public_path__ + "static/sample-projects-3-d714aacf996f3aad8966e15acb9d887b.png";